import Sidebar from "./Sidebar";
import ContentWrapper from "./ContentWrapper";

export default function MainLayout() {
  return (
    <div
      className="d-flex"
      style={{
        fontFamily: "Inter, sans-serif",
        height: "100dvh",
      }}
    >
      <Sidebar />
      <div
        className="flex-grow-1"
        style={{
          overflow: "hidden",
          minWidth: 0, // 🔥 VERY IMPORTANT
        }}
      >
        <ContentWrapper />
      </div>
    </div>
  );
}
